module.exports = "/images/vendor/flag-icon-css/flags/1x1/ru.svg?e3ee3b099783ef393f2f4dabdc75d5bc";